module.exports = __webpack_public_path__ + "img/the-poppy-war.879001f9.png";